import $ from 'jquery';
///////////////////////
/// helper functions //
///////////////////////

var $html = $('html');

function isUndefined(obj) {
  return typeof obj === 'undefined';
}

function isDefined(obj) {
  return !isUndefined(obj);
}

function isNumeric(number) {
  if(isUndefined(number)){
    return false;
  }
  return !isNaN(number) && isFinite(number);
}

function numberFormat(num) {

  var y = num.toString().split('.');
  if(num > 9999) {y[0] = y[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');}
  
  return y.join(','); 
}

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

///////////////////////
/// device detection //
///////////////////////

var oldBrowser, mobile, smartphone, clickEvent;

function initVars() {
  oldBrowser = !(('querySelector' in document) && ('localStorage' in window) && ('addEventListener' in window));
  mobile = !isUndefined(window.orientation);
  smartphone = /android.*mobile|mobile.*android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  clickEvent = 'click';
}

initVars();

function addHelperClasses() {
  var classList = window.innerWidth < 640 ? 'is-mobile' : '';
  $('html').addClass(classList);
}

//////////////////
/// geo helpers //
//////////////////

var geo = {
	berlinCenter : [52.52, 13.4],
	berlinBounds : [[51, 12.924], [54.5, 13.8249]]
};

geo.geoCode = function(search) {
  var url = 'http://interaktiv.morgenpost.de/php-scripts/geocode.php?search=' + search;
  return $.ajax({
    url : url,
    type: 'GET',
    dataType: 'json'
  });
}

geo.reverseGeoCode = function(lat, lng) {

}

geo.getZoomByWindowSize = function() {
  var mapZoom = 7,
      screenWidth = window.innerWidth;

  if (smartphone || screenWidth < 500) {
    mapZoom = 6;
  }
 
  return mapZoom;
}

geo.getViewByWindowSize = function(){

  var zoom = geo.getZoomByWindowSize();
  var latlng = [51, 13];

  return {zoom, latlng};
}

function sortData(key){
  return (a, b) => {
    if(a[key] < b[key]){
      return 1;
    }

    if(b[key] < a[key]){
      return -1;
    }

    return 0;
  } 
}

function activateMapMode(){
  $html.addClass('is-map-mode');
}

function deactivateMapMode(){
  $html.removeClass('is-map-mode');
}

function activateTextMode(){
  $html.addClass('is-text-mode');
}

function deactivateTextMode(){
  $html.removeClass('is-text-mode');
}

function createHrefs(data){

  var fbTitle = 'Zugezogenen-Atlas: ' + data.formattedPop + ' Jenaer kommen aus ' + data.name;
  var fbText = 'Gebürtige Jenaer sind in Jena in der Minderheit. Eine interaktive Karte zeigt, aus welchen Städten die Zugezogenen ursprünglich stammen.';
  var twitterText = data.formattedPop + ' Jenaer sind in ' + data.name + ' geboren. @OTZonline zeigt, aus welchen Städten die Zugezogenen kommen.';

  return {
    hrefFb : 'https://www.facebook.com/dialog/share?app_id=232725513730753&display=popup&href=http%3A%2F%2Finteraktiv.otz.de/jenaer-zugezogenen-atlas&title=' + encodeURIComponent(fbTitle) + '&description=' + encodeURIComponent(fbText) + '',
    hrefTwitter : 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(twitterText) + '&url=http%3A%2F%2Finteraktiv.otz.de/jenaer-zugezogenen-atlas&original_referer=http%3A%2F%2Finteraktiv.otz.de/jenaer-zugezogenen-atlas'
  }

}

export function animateHeadline() {
  console.log('animate headline');
  $('.intro').addClass('is-animated-headline');
}
//////////////////
/// api exports //
//////////////////

module.exports = {
	isUndefined : isUndefined,
  isDefined: isDefined,
	isNumeric : isNumeric,
	numberFormat : numberFormat,

	isOldBrowser : oldBrowser,
	isMobile : mobile,
	isSmartphone : smartphone,
  clickEvent : clickEvent,
	updateDevices : initVars,

  sortData: sortData,
  debounce: debounce,
	geo : geo,

  activateMapMode: activateMapMode,
  deactivateMapMode: deactivateMapMode,
  activateTextMode: activateTextMode,
  deactivateTextMode: deactivateTextMode,

  createHrefs: createHrefs,

  addHelperClasses: addHelperClasses,
  animateHeadline
}